import sentinel from './slices/sentinel';
import user from './slices/user';

export const reducerList = {
	user,
	sentinel
};

export type ReducerType = {
	[Key in keyof typeof reducerList]: ReturnType<(typeof reducerList)[Key]>;
};

export default reducerList;
